import { Check } from "lucide-react"

interface FeatureCheckProps {
  value: boolean | string
  color: string
  lightColor: string
}

export function FeatureCheck({ value, color, lightColor }: FeatureCheckProps) {
  if (value === true) {
    return (
      <div className="flex justify-center">
        <div
          className={`h-7 w-7 rounded-full flex items-center justify-center feature-check`}
          style={{ backgroundColor: lightColor }}
        >
          <Check className="h-4 w-4" style={{ color }} />
        </div>
      </div>
    )
  }

  if (value === "-" || value === "—") {
    return <span className="text-[#86868b]">—</span>
  }

  return <span>{value}</span>
}
